"use client"

import { useState } from "react"
import { History } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

type ChangelogRelease = {
  version: string
  date: string | null
  items: string[]
}

/** Журнал версий сервиса. Пустой список — кнопку не показывает. */
export function ChangelogDialog({
  releases,
  description,
}: {
  releases: ChangelogRelease[]
  description: string
}) {
  const [open, setOpen] = useState(false)

  if (releases.length === 0) return null

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="gap-1.5 whitespace-nowrap"
        onClick={() => setOpen(true)}
      >
        <History className="h-4 w-4 shrink-0" />
        История изменений версий
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex max-h-[90vh] flex-col gap-0 p-0 sm:max-w-2xl">
          <DialogHeader className="border-b border-border p-4 pr-12">
            <DialogTitle>История изменений версий</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>

          <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6">
            <div className="flex flex-col gap-5">
              {releases.map((release, index) => (
                <section
                  key={`${release.version}-${release.date ?? ""}-${index}`}
                  className={index === 0 ? undefined : "border-t border-border pt-5"}
                >
                  <h3 className="text-sm font-semibold text-foreground">{release.date} - {release.version}</h3>
                  <ul className="mt-2 list-disc space-y-1.5 pl-4 text-sm leading-relaxed text-muted-foreground">
                    {release.items.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>

          <DialogFooter className="m-0">
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>
              Закрыть
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
